const STYLES: Record<string, { bg: string; fg: string; label: string }> = {
  not_started: { bg: "hsl(210,16%,93%)", fg: "hsl(215,16%,40%)", label: "Not Started" },
  in_progress: { bg: "hsl(210,55%,92%)", fg: "hsl(210,100%,28%)", label: "In Progress" },
  completed: { bg: "hsl(142,55%,92%)", fg: "hsl(142,72%,28%)", label: "Completed" },
  at_risk: { bg: "hsl(32,90%,92%)", fg: "hsl(32,90%,35%)", label: "At Risk" },
  delayed: { bg: "hsl(0,70%,94%)", fg: "hsl(0,70%,40%)", label: "Delayed" },
  cancelled: { bg: "hsl(210,16%,93%)", fg: "hsl(215,16%,40%)", label: "Cancelled" },
};

export function MilestoneStatusBadge({ status }: { status: string }) {
  const s = STYLES[status] ?? STYLES.not_started;
  return (
    <span
      className="inline-flex items-center rounded-full px-2 py-0.5 text-[11px] font-medium"
      style={{ background: s.bg, color: s.fg }}
    >
      {s.label}
    </span>
  );
}
